import { TextField } from '@mui/material';
import { useSyncedInputValue } from './useSyncedInputValue';

interface InputEditorProps {
    type: 'text' | 'number' | 'date';
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

function InputEditor({ type, value, onChange, placeholder }: InputEditorProps) {
    const inputRef = useSyncedInputValue(value);

    return (
        <TextField
            inputRef={inputRef}
            type={type}
            size="small"
            fullWidth
            defaultValue={value}
            onBlur={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            InputLabelProps={type === 'date' ? { shrink: true } : undefined}
        />
    );
}

export default InputEditor;
